/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 並び順（asc または desc）
 * @export
 * @enum {number}
 */
export enum SortOrderEnum {
    /** 昇順 */
    ASC = 'asc',
    /** 降順 */
    DESC = 'desc'
}

/**
 * 並び順（asc または desc） の Union 型
 * @export
 * @typedef SortOrder
 */
export type SortOrder =
  typeof SortOrderEnum[keyof typeof SortOrderEnum];

/**
 * 並び順（asc または desc） のラベルマップ
 * @export
 */
export const SortOrderLabels = {
    /**
     * 数値キー: SortOrderEnum.ASC
     * 名前キー:  ASC
     */
    [SortOrderEnum.ASC]: '昇順',
    ASC:                             '昇順',
    /**
     * 数値キー: SortOrderEnum.DESC
     * 名前キー:  DESC
     */
    [SortOrderEnum.DESC]: '降順',
    DESC:                             '降順',
} as const;

/**
 * 並び順（asc または desc） のラベル Union 型
 * @export
 * @typedef SortOrderLabel
 */
export type SortOrderLabel =
  typeof SortOrderLabels[keyof typeof SortOrderLabels];

/**
 * 並び順（asc または desc） のラベル取得関数
 * @export
 * @param { SortOrder } value - 列挙体の値
 * @returns { SortOrderLabel } ラベル文字列
 */
export function getSortOrderLabel(
  value: SortOrder
): SortOrderLabel {
  return SortOrderLabels[value];
}

/**
 * 並び順（asc または desc） のラベル配列を取得する関数
 * @export
 * @param { SortOrder[] } values - 列挙体の値配列
 * @returns { SortOrderLabel[] } ラベル文字列配列
 */
export function getSortOrderLabels(values: SortOrder[]): SortOrderLabel[] {
  return values.map((value) => getSortOrderLabel(value));
}

/**
 * 並び順（asc または desc） のラベル配列
 * @export
 */
export const SortOrderLabelList = [
  '昇順','降順',
] as const;

